module.exports = "<nav class=\"chat-sidebar\">\n    <ul class=\"chat-sidebar-list\">\n        <li *ngFor=\"let channel of channels\" (click)=\"onNav(channel.url)\" [ngClass]=\"{'chat-sidebar-item':true, 'active':nav.includes(channel.url)}\">\n            {{channel.name}}\n        </li>\n    </ul>\n</nav>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/icontact/chat/side-bar/sidebar.component.html
// module id = ./src/app/pages/admin/icontact/chat/side-bar/sidebar.component.html
// module chunks = main